export enum PropertyFlatType {
    STANDARD = 1,
    PENTHOUSE = 2,
    APARTMENT = 3
}
export enum PropertyFlatType {
    STANDARD = 1,
    PENTHOUSE = 2,
    APARTMENT = 3
}
